// src/components/SettingsDrawer.jsx
import { useEffect } from "react";
import SettingsPanel from "./Settings";

export default function SettingsDrawer({ open, onClose, isRetrying, ...settingsProps }) {
  // Escape key closes modal
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  return (
    <div style={{
      position:      "fixed", inset: 0,
      zIndex:        9998,
      pointerEvents: open ? "auto" : "none",
      display:       "flex", alignItems: "center", justifyContent: "center",
    }}>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position:   "absolute", inset: 0,
          background: open ? "rgba(0,0,0,0.6)" : "rgba(0,0,0,0)",
          transition: "background 0.25s ease",
        }}
      />

      {/* Modal panel */}
      <div style={{
        position:      "relative",
        width:         720,
        height:        "80vh",
        background:    "var(--surface)",
        borderRadius:  "var(--radius-lg)",
        border:        "1px solid var(--border)",
        display:       "flex",
        flexDirection: "column",
        opacity:       open ? 1 : 0,
        transform:     open ? "scale(1)" : "scale(0.96)",
        transition:    "opacity 0.2s ease, transform 0.2s ease",
        overflow:      "hidden",
        zIndex:        1,
        boxShadow:     open ? "0 24px 64px rgba(0,0,0,0.6)" : "none",
      }}>
        {/* Modal header */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "14px 24px",
          borderBottom: "1px solid var(--border)",
          flexShrink: 0,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
            <span style={{ color: "var(--text-primary)", fontSize: 12, fontWeight: 600, letterSpacing: "0.1em" }}>
              SETTINGS
            </span>
            {isRetrying && (
              <span style={{
                fontSize: 10, color: "var(--text-secondary)",
                fontFamily: "var(--font-mono)", letterSpacing: "0.05em",
                display: "flex", alignItems: "center", gap: 5,
              }}>
                <span style={{
                  width: 6, height: 6, borderRadius: "50%",
                  background: "var(--accent)", opacity: 0.7,
                  animation: "pulse 1.4s ease-in-out infinite",
                }} />
                SYNCING PREFERENCES...
              </span>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border:     "1px solid var(--border)",
              borderRadius: "var(--radius-sm)",
              color:      "var(--text-secondary)",
              fontSize: 14, width: 28, height: 28,
              cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontFamily: "inherit",
              transition: "border-color 0.15s, color 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--negative)"; e.currentTarget.style.color = "var(--negative)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)";   e.currentTarget.style.color = "var(--text-secondary)"; }}
          >
            ×
          </button>
        </div>

        {/* Settings panel — fills remaining height */}
        <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
          <SettingsPanel {...settingsProps} />
        </div>
      </div>
    </div>
  );
}
